module.exports = __webpack_public_path__ + "static/rajeunir-magazine-couverture-7bf23594609b009b09a454b24edb2ac4.jpg";